import { Box, Flex, Input, InputGroup, InputRightElement } from '@chakra-ui/react'
import { FB, LINKEDIN } from '@root/assets/icons'
import { CustonButtom } from '@root/components/common/button/customButton'
import { CustomText } from '@root/components/common/components'
import { copyTextToClipboard } from '@root/utils/helpers'
import { t } from 'i18next'
import {
    FacebookShareButton,
    LinkedinShareButton
} from 'react-share'


function SharePopup({ text, showToast }: any) {
    return (
        <Flex flexDir={"column"} gap={"16px"} py={"16px"}>
            <Flex gap={"32px"}>
                <FacebookShareButton
                    url={text}
                >
                    <Box
                        cursor={'pointer'}
                    >
                        <img src={FB} alt="" />
                        <CustomText
                            mt={"12px"}
                            textAlign={"center"}
                            fontSize={"12px"}
                            type="grayText"
                            text={t('common:translate.facebook')}
                            color={'theme.gray.lightGray500to200'}
                        />
                    </Box>
                </FacebookShareButton>
                {/* <Box
                    cursor={'pointer'}
                    onClick={githubShareHandler}
                >
                    <img src={GITHUB} alt="" />
                    <CustomText
                        mt={"12px"}
                        textAlign={"center"}
                        fontSize={"12px"}
                        type="grayText"
                        text="Github"
                        color={'theme.gray.lightGray500to200'}
                    />
                </Box> */}
                <LinkedinShareButton
                    url={text}
                >
                    <Box
                        cursor={'pointer'}
                    >
                        <img src={LINKEDIN} alt="" />
                        <CustomText
                            mt={"12px"}
                            textAlign={"center"}
                            fontSize={"12px"}
                            type="grayText"
                            text={t('common:translate.linkedin')}
                            color={'theme.gray.lightGray500to200'}
                        />
                    </Box>
                </LinkedinShareButton>

            </Flex>
            <Box>
                <CustomText text={t('common:chat.copyLink')} fontSize={"18px"} fontWeight={500} />
                <Box mt={"16px"}>
                    <InputGroup>
                        <InputRightElement
                            cursor={"pointer"}
                            children={
                                <CustonButtom
                                    text={t('common:translate.copy')}
                                    height="60%"
                                    padding="5px 10px"
                                    mr={"30px"}
                                        minW={'50px'}
                                        display={'flex'}
                                        justifyContent={'center'}
                                        alignItems={'center'}
                                    fontSize="12px"
                                    // @ts-ignore
                                    onClick={() => copyTextToClipboard(text, showToast)}
                                />
                            }
                        />
                        <Input
                            value={text}
                            variant="outline"
                            size="xs"
                            _disabled={{ color: "theme.text.primaryDark" }}
                            disabled
                            pr={'80px'}
                        />
                    </InputGroup>
                </Box>
            </Box>
        </Flex>
    )
}

export default SharePopup
